import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_USER = restRequest("VRCORE_USER_PROFILE.GET_USER");
export const GET_QUALIFICATION_CATEGORIES = restRequest(
    "VRCORE_USER_PROFILE.GET_QUALIFICATIONS"
);

export const SET_EDIT_QUAL_MODAL_INFO =
    "VRCORE_USER_PROFILE.SET_EDIT_QUAL_MODAL_INFO";
export const SET_UPDATED_QUAL_INFO = restRequest(
    "VRCORE_USER_PROFILE.SET_UPDATED_QUAL_INFO"
);
export const SET_UPDATED_PROFILE_INFO = restRequest(
    "VRCORE_USER_PROFILE.SET_UPDATED_PROFILE_INFO"
);

export const GET_LOGGED_UID = restRequest("VRCORE_USER_PROFILE.GET_LOGGED_UID");
export const SET_SNACKBAR_STATE = "VRCORE_USER_PROFILE.SET_SNACKBAR_STATE";
export const SET_SINGLE_PROFILE_VALUE = restRequest(
    "VRCORE_USER_PROFILE.SET_SINGLE_PROFILE_VALUE"
);
export const GET_ALL_USERS = restRequest("VRCORE_USER_PROFILE.GET_ALL_USERS");
export const GET_PROFILE = restRequest("VRCORE_USER_PROFILE.GET_PROFILE");

export const UPDATE_SELECTED_USER_PASSWORD = restRequest(
    "VRCORE_USER_PROFILE.UPDATE_SELECTED_USER_PASSWORD"
);
export const GET_DEPARTMENTS = restRequest(
    "VRCORE.UMV4_ADD_USER_WIDGET.GET_DEPARTMENTS"
);
export const GET_AREAS = restRequest("VRCORE.UMV4_ADD_USER_WIDGET.GET_AREAS");
export const GET_USERTYPES = restRequest("VRCORE_USER_PROFILE.GET_USERTYPES");
export const UPLOAD_FILE = restRequest("VRCORE_USER_PROFILE.UPLOAD_FILE");
export const GET_USER_JOBPACKS = restRequest(
    "VRCORE.VRCORE_USER_PROFILE.GET_USER_JOBPACKS"
);
export const GET_USER_INSPECTION = restRequest(
    "VRCORE.VRCORE_USER_PROFILE.GET_USER_INSPECTION"
);